/**
 * 媒体
 */

import { HTTP_ALB } from '../axios'

//  媒体列表
export const getplatformlist = params => {
  return HTTP_ALB.get('/system/platform/list', params)
}

// 添加媒体
export const addplatform = params => {
  return HTTP_ALB.post('/system/platform/add', params)
}
// 编辑媒体
export const editplatform = params => {
  return HTTP_ALB.post('/system/platform/edit', params)
}
